import Tippy from "@tippyjs/react";
import React, { useEffect, useState } from "react";
import Icon1 from "../icons/Icon";

function TextField2AC({
  label,
  value = "",
  mandatory = false,
  noborder = false,
  type = "text",
  mandatory_characters = [],
  min = 0,
  max = 100,
  onChange = () => {},
  className = "",
  autoComplete = "off",
  transparent = true,
  onEnter = () => {},
  focusOnStart = false,
  disabled = false,
  items = [],
  useSuggestedValue = () => {},
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };
  const [suggestedValue, setSuggestedValue] = useState(null);

  const handleChange = (e) => {
    onChange(e);

    const found = items.find((item) =>
      item.label.toLowerCase().includes(e.target.value.toLowerCase())
    );

    if (found && e.target.value?.length > 0) {
      setSuggestedValue(found);
    } else {
      setSuggestedValue(null);
    }
  };

  return (
    <div className={`w-full ${className}`}>
      <Tippy
        content={label}
        delay={500}
        className="custom-tooltip"
        disabled={!label}
      >
        <div className={`flex relative flex-row justify-between items-center`}>
          <input
            disabled={disabled}
            type={type} // Force text input type to avoid unwanted number input behavior
            min={min}
            max={max}
            placeholder={label}
            value={value === null ? "" : value}
            autoFocus={focusOnStart}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            autoComplete={autoComplete}
            className={`
          w-full
          min-h-8
          h-fit
         
          rounded-xl
          ${noborder ? "" : "border focus:border-2 focus:border-blue-300  px-2  py-1"}
          ${
            (mandatory && !value) ||
            mandatory_characters.some((char) => !value.includes(char))
              ? "border-red-500"
              : "border-gray-300"
          }
          
          outline-none
          transition
          ease-in-out
          duration-150
          ${disabled ? "bg-neutral-100 text-shadow_25" : transparent ? "bg-transparent" : "bg-white"}      
        `}
            style={{
              fontSize: "14px",
            }}
          />

          {suggestedValue && (
            <div
              onClick={() => useSuggestedValue(suggestedValue)}
              className="cursor-pointer absolute right-0  hover:text-blue-700 hover:bg-blue-100 flex max-w-c200 justify-center w-fit text-h4 text-blue-500 bg-blue-50 rounded-lg py-1 px-3 m-2"
            >
              Utiliser @{suggestedValue.label}
            </div>
          )}
        </div>
      </Tippy>
    </div>
  );
}

export default TextField2AC;
